import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const PrivacySection = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [settings, setSettings] = useState({
    profileVisibility: true,
    showEmail: false,
    showPhone: false,
    allowMessages: true,
    shareWithRecruiters: true,
    showApplicationHistory: false,
    allowDataAnalytics: true
  });

  const handleCheckboxChange = (key) => {
    setSettings(prev => ({ ...prev, [key]: !prev?.[key] }));
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Shield" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Privacy & Data</h2>
            <p className="text-sm text-muted-foreground">Control your privacy and data sharing preferences</p>
          </div>
        </div>
        {!isEditing && (
          <Button
            variant="outline"
            size="sm"
            iconName="Edit2"
            iconPosition="left"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </Button>
        )}
      </div>
      <div className="space-y-6">
        <div>
          <h3 className="text-sm font-medium text-foreground mb-4">Profile Visibility</h3>
          <div className="space-y-3">
            <Checkbox
              label="Make my profile visible to recruiters"
              description="Allow recruiters to discover and contact you"
              checked={settings?.profileVisibility}
              onChange={() => handleCheckboxChange('profileVisibility')}
              disabled={!isEditing}
            />
            <Checkbox
              label="Show email address on profile"
              description="Display your email to potential employers"
              checked={settings?.showEmail}
              onChange={() => handleCheckboxChange('showEmail')}
              disabled={!isEditing}
            />
            <Checkbox
              label="Show phone number on profile"
              description="Display your phone number to recruiters"
              checked={settings?.showPhone}
              onChange={() => handleCheckboxChange('showPhone')}
              disabled={!isEditing}
            />
          </div>
        </div>

        <div className="pt-6 border-t border-border">
          <h3 className="text-sm font-medium text-foreground mb-4">Communication Preferences</h3>
          <div className="space-y-3">
            <Checkbox
              label="Allow direct messages from recruiters"
              description="Receive messages about job opportunities"
              checked={settings?.allowMessages}
              onChange={() => handleCheckboxChange('allowMessages')}
              disabled={!isEditing}
            />
            <Checkbox
              label="Share profile with partner recruiters"
              description="Allow verified recruitment partners to view your profile"
              checked={settings?.shareWithRecruiters}
              onChange={() => handleCheckboxChange('shareWithRecruiters')}
              disabled={!isEditing}
            />
          </div>
        </div>

        <div className="pt-6 border-t border-border">
          <h3 className="text-sm font-medium text-foreground mb-4">Data Usage</h3>
          <div className="space-y-3">
            <Checkbox
              label="Show my application history"
              description="Display past applications on your profile"
              checked={settings?.showApplicationHistory}
              onChange={() => handleCheckboxChange('showApplicationHistory')}
              disabled={!isEditing}
            />
            <Checkbox
              label="Allow data for analytics and improvements"
              description="Help us improve the platform with anonymous usage data"
              checked={settings?.allowDataAnalytics}
              onChange={() => handleCheckboxChange('allowDataAnalytics')}
              disabled={!isEditing}
            />
          </div>
        </div>

        {isEditing && (
          <div className="flex flex-wrap gap-3 pt-4 border-t border-border">
            <Button
              variant="default"
              iconName="Check"
              iconPosition="left"
              onClick={handleSave}
            >
              Save Changes
            </Button>
            <Button
              variant="outline"
              iconName="X"
              iconPosition="left"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacySection;